(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.carousel-container').forEach(container=>{
    const track = container.querySelector('.carousel-track');
    const prev = container.querySelector('.carousel-btn--prev');
    const next = container.querySelector('.carousel-btn--next');
    if(!track||!prev||!next) return;

    function getScrollAmount(){
      const item = track.querySelector('.grid-product');
      return item ? item.getBoundingClientRect().width + 20 : container.getBoundingClientRect().width*0.8;
    }
    function updateButtons(){
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft<=0;
      next.disabled = track.scrollLeft>=max;
    }
    prev.addEventListener('click',()=>{ track.scrollBy({left:-getScrollAmount(),behavior:'smooth'}); });
    next.addEventListener('click',()=>{ track.scrollBy({left:getScrollAmount(),behavior:'smooth'}); });
    track.addEventListener('scroll',()=>requestAnimationFrame(updateButtons));
    updateButtons();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
